class BrandSlider extends HTMLElement {
  connectedCallback() {
    this._initSwiper();
  }

  disconnectedCallback() {
    if (this._swiper) this._swiper.destroy(true, true);
  }

  _playActiveVideo() {
    const activeSlide = this._swiper?.slides?.[this._swiper.activeIndex];
    if (!activeSlide) return;

    // Pause all videos first
    this.querySelectorAll('.brand-slider__slide-video').forEach((v) => {
      v.pause();
      v.currentTime = 0;
    });

    // Play the one in the active slide
    const activeVideo = activeSlide.querySelector('.brand-slider__slide-video');
    if (activeVideo) activeVideo.play().catch(() => {});
  }

  _initSwiper() {
    const swiperEl = this.querySelector('.brand-slider__swiper');
    if (!swiperEl || typeof Swiper === 'undefined') return;

    const speed = parseInt(this.dataset.autoplaySpeed, 10) || 4000;
    const loop = this.dataset.loop !== 'false';
    const autoplayEnabled = this.dataset.autoplayEnabled !== 'false';
    const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const paginationEl = this.querySelector('.brand-slider__pagination');

    this._swiper = new Swiper(swiperEl, {
      slidesPerView: 1,
      loop: loop,
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
      autoplay: (!autoplayEnabled || prefersReduced) ? false : {
        delay: speed,
        disableOnInteraction: false,
      },
      pagination: paginationEl ? {
        el: paginationEl,
        clickable: true,
      } : false,
      on: {
        slideChangeTransitionStart: () => this._playActiveVideo(),
      },
    });

    this._playActiveVideo();
  }
}

customElements.define('brand-slider', BrandSlider);
